
import Grid from '@mui/material/Grid';
import NewbornText from './NewbornText';
import MetabolicNewbornCard from './NewbornPanel/MetabolicNewbornCard';
import SectionStructure from '../../../../../components/Section/SectionStructure';
import NewbornButtonGroup from './NewbornPanel/NewbornButtonGroup';
import MetabolicFattyAcidCard from './NewbornPanel/MetabolicFattyAcidCard';
import MetabolicAminoAcidCard from './NewbornPanel/MetabolicAminoAcidCard';
import EndocrineNewbornCard from './NewbornPanel/EndocrineNewbornCard';
import HemoglobinCard from './NewbornPanel/HemoglobinCard';
import OtherNewbornCard from './NewbornPanel/OtherNewbornCard';



export default function SectionNewborn() {

    
    return (

    <SectionStructure
    
            sectiontext=    { <NewbornText /> }

            sectiondiagroup=    { <NewbornButtonGroup />} 

            sectioncards=  {<>
             
             <Grid container>
                        <Grid>  <EndocrineNewbornCard />    </Grid> 
                        <Grid>  <HemoglobinCard />          </Grid>
                        <Grid>  <MetabolicNewbornCard />    </Grid>
                        <Grid>  <MetabolicFattyAcidCard />  </Grid>
                        <Grid>  <MetabolicAminoAcidCard />  </Grid>  
                        <Grid>  <OtherNewbornCard />        </Grid>  
            </Grid>
            
        </>}
    />
)
}